import {IWinRatioConfig} from "../core/config/WinRatio";
import {IReelSets} from "../core/reel/reelset/ReelSet";
import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {Linear} from "gsap";

export class WalkOfShameGameConfig {

    // Reels
    public static REELS_NUM: number = 5;

    // Win
    public static WIN_RATIOS: IWinRatioConfig[] = [
        {
            ratio: 0,
            name: "Tiny Win",
            duration: 0,
            bigWinLevel: -1
        },
        {
            ratio: 1.5,
            name: "Small Win",
            duration: 0,
            bigWinLevel: -1
        },
        {
            ratio: 3,
            name: "Medium Win",
            duration: 0.4,
            bigWinLevel: -1
        },
        {
            ratio: 5,
            name: "Large Win",
            duration: 0.8,
            bigWinLevel: -1
        },
        {
            ratio: 15,
            name: "Big Win 1",
            duration: 3.83,
            bigWinLevel: 0
        },
        {
            ratio: 25,
            name: "Big Win 2",
            duration: 3.83,
            bigWinLevel: 1
        },
        {
            ratio: 50,
            name: "Big Win 3",
            duration: 3.83,
            bigWinLevel: 2
        },
        {
            ratio: 100,
            name: "Big Win 4",
            duration: 3.83,
            bigWinLevel: 3
        },
        {
            ratio: 250,
            name: "Big Win 5",
            duration: 3.83,
            bigWinLevel: 4
        }
    ];

    public static REEL_SETS: IReelSets = {
        "NORMAL_REELSET": [
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3", "S2",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "L3", "L2", "M4", "M3", "S2",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L4", "M3", "L2"
            ],
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3", "S",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "S",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "S", "L3", "L1",
                "M4", "M1", "L5", "M1", "S", "M2", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "S", "L3", "L2", "L2", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "L1",
                "M2", "L2", "L3", "L2", "M2", "M4", "L5", "M4", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "S",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ]
        ],
        "RESPIN_REELSET": [
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "L3", "L2", "M4", "M3", "L2",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L4", "M3", "L2"
            ],
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "M4", "L2", "M4", "M3", "L5",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L1", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "L4",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "M3", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "L1", "L2", "M4", "M3", "L2",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L5", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "L4", "L3", "L1",
                "M4", "M1", "L5", "M1", "L1", "M2", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L5", "L3", "L2", "L2", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "L2", "L2", "M4", "M3", "L1",
                "M2", "L2", "L3", "L2", "M2", "M4", "L5", "M4", "L1", "M1", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "L5",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L3", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "L1", "L2", "M4", "M3", "L4",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L3", "M3", "L2"
            ]
        ],
        "FREESPIN_REELSET": [
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3", "S2",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "L3", "L2", "M4", "M3", "S2",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L4", "M3", "L2"
            ],
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3", "S",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "S",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "S", "L3", "L1",
                "M4", "M1", "L5", "M1", "S", "M2", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "S", "L3", "L2", "L2", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "L1",
                "M2", "L2", "L3", "L2", "M2", "M4", "L5", "M4", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "S",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ]
        ],
        "SUPER_FREESPIN_REELSET": [
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3", "M2",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "L3", "L2", "M4", "M3", "L4",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L4", "M3", "L2"
            ],
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3", "S",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "S",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "S", "L3", "L1",
                "M4", "M1", "L5", "M1", "S", "M2", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "S", "L3", "L2", "L2", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "L1",
                "M2", "L2", "L3", "L2", "M2", "M4", "L5", "M4", "L1", "S", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "S",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "S", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "S", "L2", "M4", "M3", "S",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "S", "M3", "L2"
            ]
        ],
        "SUPER_FREESPIN_RESPIN_REELSET": [
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "L3", "L2", "M4", "M3", "L2",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L4", "M3", "L2"
            ],
            [
                "M1", "L1", "L2", "L2", "L2", "L4", "L5", "M3", "L2", "L4", "L3",
                "M1", "M1", "L5", "M2", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L4", "M3", "M3", "L5", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "M2", "L3", "L1", "M4", "L2", "M4", "M3", "L5",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L1", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "L4",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "M3", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "L1", "L2", "M4", "M3", "L2",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L5", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "L4", "L3", "L1",
                "M4", "M1", "L5", "M1", "L1", "M2", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L5", "L3", "L2", "L2", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "L2", "L2", "M4", "M3", "L1",
                "M2", "L2", "L3", "L2", "M2", "M4", "L5", "M4", "L1", "M1", "M3", "L2"
            ],
            [
                "M3", "L1", "L2", "L2", "L5", "L4", "L5", "M3", "L2", "M4", "L3", "L5",
                "M4", "M2", "L5", "M1", "L2", "M4", "L4", "L5", "L3", "M1", "M3", "L2",
                "L4", "L1", "L3", "L2", "L3", "L4", "M3", "M3", "L1", "M1", "L3", "L1",
                "L1", "M4", "M2", "L5", "L2", "L3", "L1", "L1", "L2", "M4", "M3", "L4",
                "M1", "L2", "L3", "L2", "M2", "M4", "L5", "M3", "L1", "L3", "M3", "L2"
            ]
        ]
    };

    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles: 50,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone
    });
    public static bigWinAnticipationWiggle2 = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles: 40,
        amplitudeEase: Linear.easeNone,
        timingEase: Linear.easeNone
    });

    public static FULL_SYM_PRESENT_LAST_REEL: boolean = false;
    public static WALK_COMPLETED: boolean = false;
    public static IS_ANTICIPATING: boolean = false;
    public static SYMBOLS_COUNT_IN_REELS: number[] = [3, 4, 4, 4, 4];
    public static IS_LUCKY_DRAW: boolean = false;

    public static getReelSetName(mode: string): string {
        return `${mode}_REELSET`;
    }
}